module.exports = __webpack_public_path__ + "img/ring_g_s_1_null.8a26be56.png";